import React, {useState, useEffect} from 'react'
import avatar from '../assets/Mawingubluelogo.png'
import Modal from 'react-modal';
import { useNavigate } from 'react-router-dom'
import axios from 'axios';
import { API_URL, secret_key, currentYear, saveLogs } from '../General'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CryptoJS from 'crypto-js';
import Swal from "sweetalert2";
import moment from 'moment';
import { useTranslation } from "react-i18next";
import Langpage from './Langpage';

const Home = () => {
    const [modalIsOpen, setmodalIsOpen] = useState(false);
    const [modal2IsOpen, setmodal2IsOpen] = useState(false);
    const [modalfIsOpen, setmodalfIsOpen] = useState(false);
    const [modal3IsOpen, setmodal3IsOpen] = useState(false);
    const [referIsOpen, setreferIsOpen] = useState(false);
    const [modalSupportIsOpen, setmodalSupportIsOpen] = useState(false);

    const [details, setDetails]=useState("")
    const [pakages, setPakages]=useState([])

    const storedData = localStorage?.getItem('user');

    const [isInputValid, setInputValid] = useState(false);

    const [selectedItem, setSelectedItem] = useState('');
    const [selectedCode, setSelectedCode] = useState('');

    const [selectedAmount, setSelectedAmount] = useState(0);

    const [wifipassword, setWifiPassword] = useState("");
    const [wifiName, setWifiName] = useState("");

    const [validatorMsg, setValidatorMsg] = useState("");
    const [offlineMsg, setOfflineMsg] = useState("");

    const [regions, setRegions] = useState([]);
    const [towns, setTowns] = useState([]);
    const [regionId, setRegionId] = useState('');
    const [selectedTown, setSelectedTown] = useState("");

    const [ticketData, setTicketData] = useState({
      issuetype: "",
      c_message: ""
    });

    const [data, setData] = useState({
      newpass: "",
      wifi_name: wifiName
    })

    const { t } = useTranslation();

    if (storedData) {
      var bytes = CryptoJS.AES.decrypt(storedData, secret_key);
      var logeduserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    }
    const custno =logeduserData.Customer_no
    const [phoneNumber, setPhoneNumber] = useState(logeduserData?.phone);

    // Helper: is this a fiber account?
    const isFibreAccount = (ip) => ip?.startsWith("10.40");

    const getCustomerDetails =() =>{
      let config = {
        method: 'post',
        maxBodyLength: Infinity, 
        url: `${API_URL}/get_customer_details`,
        headers: { 
          'Content-Type': 'application/json'
        },
          data : {
            "custno": custno
          }
      };
      
      axios.request(config)
      .then((response) => {
        setDetails(response.data)

        const cleanedString = (response.data?.package_amount)?.replace(/,/g, '');
        setSelectedAmount(parseFloat(cleanedString))

        setSelectedItem(response.data?.package_code);

        // Fetch the right wifi credentials depending on account type,
        // instead of only ever calling the non-fibre endpoint here.
        if (isFibreAccount(response.data?.ip_address)) {
          getCurrentWifiPassFibre();
        } else {
          getCurrentWifiPass(response.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
    }
  
    useEffect(() => {
      getCustomerDetails();
    }, [custno])

    const handleKeyDown = (event) => {
    if (
      !(event.key >= '0' && event.key <= '9') &&
      event.key !== 'Backspace' && 
      event.key !== 'ArrowLeft' &&
      event.key !== 'ArrowRight' &&
      event.key !== 'Delete'
    ) {
      event.preventDefault();
    }
  };

    const getPackageList =() =>{
      let config = {
        method: 'get',
        maxBodyLength: Infinity, 
        url: `${API_URL}/get_package_list/${details?.address}`,
        headers: { 
          'Content-Type': 'application/json'
        }
      };
      
      axios.request(config)
      .then((response) => {
        setPakages(response.data)
      })
      .catch((error) => {
        console.log(error);
      });
    }
  
    useEffect(() => {
      getPackageList();
    }, [details])

    // Non-fibre: fetch current wifi password
    const getCurrentWifiPass =(_details) =>{
      console.log("Fetching current WiFi password for IP:", _details?.ip_address);
      let config = {
        method: 'post',
        maxBodyLength: Infinity, 
        url: `${API_URL}/getWifiPassword`,
        headers: { 
          'Content-Type': 'application/json'
        },
        data: {
          ip: _details?.ip_address
        }
      };
      axios.request(config)
      .then((response) => {
        console.log(response.data);
        if(response.data && response.data.length < 3){
          if(_details?.ip_address && _details?.ip_address?.startsWith("10.40")){
            setOfflineMsg("")
          }else{
            setOfflineMsg("Password change error")
          }
        }else{
          setOfflineMsg("")
          setWifiPassword(response.data)
        }
      })
      .catch((error) => {
        console.log(error);
      });
    }

    // Fibre: fetch current wifi password + ssid in one call
    const getCurrentWifiPassFibre = () => {
      axios.post(`${API_URL}/fibreget_WifiPassword`, {
        customer_no: logeduserData.Customer_no
      })
      .then((response) => {
        const wifiSSID = response.data?.ssid || '';
        const wifiPass = response.data?.wifi_password || '';

        if (!wifiSSID && !wifiPass) {
          setOfflineMsg("Password change error")
        } else {
          setOfflineMsg("")
        }

        setWifiPassword(wifiPass);
        setWifiName(wifiSSID);

        setData((prev) => ({
          ...prev,
          wifi_name: wifiSSID
        }));
      })
      .catch((error) => {
        console.log("❌ Error fetching fibre WiFi details:", error);
      });
    }

    // Non-fibre: fetch current wifi name
    const getCurrentWifiName =() =>{
      let config = {
        method: 'post',
        maxBodyLength: Infinity, 
        url: `${API_URL}/getwifi_name`,
        headers: { 
          'Content-Type': 'application/json'
        },
        data: {
          ip: details?.ip_address
        }
      };
      axios.request(config)
      .then((response) => {
        if(response.data && response.data.wifi_name.trim().length == ""){
          if(details?.ip_address && details?.ip_address?.startsWith("10.40")){
            setOfflineMsg("")
          }else{
            setOfflineMsg("Password change error")
          }
        }else{
          setOfflineMsg("")
          setWifiName(response.data.wifi_name)

          setData({...data, 
            wifi_name:response.data.wifi_name
          })
        }
      })
      .catch((error) => {
        console.log(error);
      });
    }
  
    // Only fetch wifi name via the non-fibre endpoint for non-fibre accounts.
    // Fibre accounts already get their ssid from getCurrentWifiPassFibre().
    useEffect(() => {
      if(details && !isFibreAccount(details?.ip_address)){
        getCurrentWifiName();
      }
    }, [details])

    let navigate = useNavigate();

    const openModal = () => {
      setmodalIsOpen(true);
    }
    const closeModal = () => {
      setmodalIsOpen(false);
      }
    const openModal2 = () => {
      setmodal2IsOpen(true);
    }
    const closeModal2 = () => {
      setmodal2IsOpen(false);
      setValidatorMsg("")
      setErrorMessage("")
      }

    const openModalSupport = () => {
      setmodalSupportIsOpen(true);
    }
    const closeModalSupport = () => {
      setmodalSupportIsOpen(false);
      setErrorMessage("")
    }

      const openModalf = async () => {
        try {
          const response = await axios.post(`${API_URL}/fibreget_WifiPassword`, {
            customer_no: logeduserData.Customer_no
          });
      
          const wifiSSID = response.data?.ssid || '';
          const wifiPass = response.data?.wifi_password || '';
      
          setWifiPassword(wifiPass);
          setWifiName(wifiSSID);
      
          setData((prev) => ({
            ...prev,
            wifi_name: wifiSSID
          }));
      
          setmodalfIsOpen(true);
        } catch (error) {
          console.error("❌ Error fetching WiFi details:", error);
          toast.error("Failed to load WiFi details.");
        }
      };
      
      const closeModalf = () => {
        setmodalfIsOpen(false);
        setValidatorMsg("")
        setErrorMessage("")
        }
      const openModal3 = () => {
        setmodal3IsOpen(true);
      }
      const closeModal3 = () => {
        setmodal3IsOpen(false);
        setValidatorMsg("")
        setErrorMessage("")
      }

    const openReferModal = () => {
      setreferIsOpen(true);
    }

    const closeReferModal = () => {
      setreferIsOpen(false);
    }
      
    const handlePhoneChange = (e) =>{
        setPhoneNumber(e.target.value)
    }
    const handlePkgChange = (e) =>{
        setSelectedAmount(e.target.value)
    }
    const handleChange = (e) =>{
      setErrorMessage("")
      const newdata = { ...data }
      const { id, value } = e.target;
      if (id === 'wifi_name') {
    const sanitizedValue = value.replace(/[^A-Za-z0-9]/g, '');
    newdata[id] = sanitizedValue;
  } else {
    newdata[id] = value;
  }
      
      setData(newdata)
  }

   const handleFocus = () => {
    if(data.newpass.length < 8){
      setValidatorMsg("Password should be at least 8 characters, should not have a space")
    }else{
      setValidatorMsg("")
    }
   }

   const handlekeydown = (event) => {
    if (event.code === 'Space') event.preventDefault()
   }

    const [loading, setLoading] = useState(false);
    const [newPassword, setNewPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const customStyles = {
      content: {
        position: 'fixed',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        transform: 'translate(-50%, -50%)',
        border: 'none',
        borderRadius: '10px',
        padding: 0,
        width: '90vw',
        maxWidth: '400px',
        maxHeight: '85vh',
        overflowY: 'auto',
      },
      overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0,0,0,0.5)',
        zIndex: 1000,
      },
    };

    const isFormValid = () => {
      return phoneNumber != '' && selectedAmount != 0;
    };

    useEffect(() => {
      const isValid = isFormValid();
      setInputValid(isValid);
    }, [phoneNumber, selectedAmount]);
    
    const paySubscription = (e) => {
        e.preventDefault();
        setLoading(true);
        let formData = {
            "phone": phoneNumber ,
            "amount": selectedAmount,
            "account_number": custno
          };

        let config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: `${API_URL}/deposit_fund`,
          headers: { 
            'Content-Type': 'application/json'
          },
          data : formData
        };
              
        axios.request(config)
        .then((response) => { 
          setLoading(false);  
          toast('Payment initiated Enter your M-PESA Pin!');
          saveLogs(logeduserData.Customer_no, logeduserData.phone,"Renew subscription submit", details?.email_address)

          let updateData = {
            "CustomerNo": custno,
            "newpackage": selectedCode
          };
    
          let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${API_URL}/update_package`,
            headers: { 
              'Content-Type': 'application/json'
            },
            data : updateData
          };
                
          axios.request(config)
          .then((response) => { 
        })
        .catch((error) => {
            console.log(error) 
          });

          setTimeout(()=>{
            navigate(0);
          }, 4000)
        })
        .catch((error) => {
          console.log(error) 
        });
    }

    function capitalizeFirstLetter(fullname) {
      if (!fullname) return '';
    
      const nameParts = fullname.split(" ");
      const firstName = nameParts[0] || '';
      const capitalizedFirstName = firstName.charAt(0).toUpperCase() + firstName.slice(1);
    
      return capitalizedFirstName;
    }
    
    const changeWifiPass = (e) =>{
      e.preventDefault();
      setLoading(true);

      let formData = {
        "ipAddress": details?.ip_address,
        "custno": logeduserData.Customer_no,
        "password": data.newpass,
        "wifi_name": data.wifi_name
      };
      if(data.newpass.length < 8){
        setErrorMessage("Password should be at least 8 characters");
        setLoading(false)
        return;
      }
      else{
        let config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: `${API_URL}/change_WifiPassword`,
          headers: { 
            'Content-Type': 'application/json'
          },
          data : formData
        };
        
        axios.request(config)
        .then((response) => {
          let config = {
            method: 'post',
            maxBodyLength: Infinity, 
            url: `${API_URL}/getWifiPassword`,
            headers: { 
              'Content-Type': 'application/json'
            },
            data: {
              ip: details?.ip_address
            }
          };
          axios.request(config)
          .then((response) => {
            setErrorMessage("")
          setLoading(false);
            saveLogs(logeduserData.Customer_no, logeduserData.phone,"Change wifi submit", details?.email_address)
            
            if(response.data.length < 3){
              Swal.fire({
                icon: "error",
                title: "Error!",
                html: 'Your password was not updated</br> Check if your router is powered on'
              })
              .then(() => {
                navigate(0); 
              });
            }

            if(response.data.toString().replace(/\r?\n|\r/g, ' ').replace(/\s/g, '') != data.newpass.replace(/ /g, '')){
              Swal.fire({
                icon: "error",
                title: "Error!",
                html: 'Try Again </br>Check your internet connection.'
              })
              .then(() => {
                navigate(0); 
              });
            }else{  
              Swal.fire({
                icon: "success",
                title: "Success!",
                text: "Your new password is "+response.data,
              })
              .then(() => {
                navigate(0); 
              });
            }
          })
          .catch((error) => {
            console.log(error);
          });
          
        })
        .catch((error) => {
          setLoading(false);
          setErrorMessage(error?.response?.data?.error)
        });
  
      }     
    }

    const changeWifif = async (e) => {
      e.preventDefault();
      setLoading(true);
    
      const newPassword = data.newpass?.trim();
      const wifiName = data.wifi_name?.trim();
    
      if (!newPassword || newPassword.length < 8) {
        setValidatorMsg("⚠️ Password should be at least 8 characters");
        setLoading(false);
        return;
      } else {
        setValidatorMsg("");
      }
    
      const formData = {
        customer_no: logeduserData.Customer_no,
        ssid: wifiName,
        password: newPassword,
      };
    
      try {
        const updateRes = await axios.post(`${API_URL}/fibreupdate_WifiPassword`, formData, {
          headers: { "Content-Type": "application/json" },
          maxBodyLength: Infinity,
        });
    
        if (updateRes.status === 200 && updateRes.data.status === true && updateRes.data.response_code === 'success') {
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: `Your new WiFi password has been updated successfully.`,
          }).then(() => navigate(0));
    
          setLoading(false);
        } else {
          setErrorMessage("Failed to update WiFi password.");
          setLoading(false);
        }
      } catch (error) {
        setErrorMessage(error?.response?.data?.error || "Something went wrong");
        setLoading(false);
      }
    };

    const removeError = () => {
      setErrorMessage("")
    }

    const logout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        navigate(0)
    };

    const handleInvoicesClick = () =>{
      navigate("/invoices")
    }
    const handleReceiptsClick = () =>{
      navigate("/receipts")
    }
 
    const handleConnectedClick = (e) => {
      navigate("/devices")
    }
 
    const formattedDate = moment(details?.disconnection_date).format('DD/MMM/YYYY');
    const renewalDate = moment(details?.disconnection_date);
    const today = moment();

    const daysRemaining = Math.max(0, renewalDate.diff(today, "days"));

    const handleSelectionChange = (event) => {
      const selectedDes = event.target.value;
      const selectedData = pakages.find(pk => pk.Description === selectedDes);
  
      if (selectedData) {
        setSelectedItem(selectedDes);
        setSelectedCode(event.target.options[event.target.selectedIndex].id)
        setSelectedAmount(parseFloat((selectedData.Amount)?.replace(/,/g, '')));
      }
    };

    const [pindata, setpinData] = useState({
      pin: "",
      cpin: "",
      custno: logeduserData.Customer_no,
      phone: logeduserData.phone
    })

    const handlePinChange = (e) =>{
      const newdata = { ...pindata }
      newdata[e.target.id] = e.target.value
      setpinData(newdata)
  }

  const handleTicketChange = (e) => {
    const newdata = { ...ticketData };
    newdata[e.target.id] = e.target.value;
    setTicketData(newdata);
  }

  const createTicket = (e) => {
    e.preventDefault();

    if (!ticketData.issuetype || !ticketData.c_message.trim()) {
      setErrorMessage("Please select an issue type and enter a message");
      return;
    }

    setLoading(true);

let formData = {
      "customer_no": logeduserData.Customer_no,
      "category": ticketData.issuetype,
      "message": ticketData.c_message
    };
    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${API_URL}/create_ticket`,
      headers: {
        'Content-Type': 'application/json'
      },
      data: formData
    };

    axios.request(config)
      .then((res) => {
        setLoading(false);
        saveLogs(logeduserData.Customer_no, logeduserData.phone, "Support ticket submit", details?.email_address)

        if (res.data.success == 1) {
          Swal.fire({
            icon: "success",
            title: "Success!",
            html: res.data.message || "Your support ticket has been submitted"
          }).then(() => {
            setTicketData({ issuetype: "", c_message: "" });
            closeModalSupport();
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Error!",
            html: res.data.message || "An error occurred. Try again later"
          })
        }
      })
      .catch((error) => {
        setLoading(false);
        setErrorMessage(error?.response?.data?.error || "Something went wrong")
      });
  }

  const changeMyPin = (e) => {
    e.preventDefault();
    if(pindata.pin.toString().length !== 4){
      Swal.fire({
        icon: "error",
        title: "Error!",
        html: 'The pin should have 4 digits'
      })
    }else if(pindata.pin !== pindata.cpin){
      Swal.fire({
        icon: "error",
        title: "Error!",
        html: 'The pins do not match'
      })
    }else{
      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${API_URL}/pass_update`,
        headers: { 
          'Content-Type': 'application/json'
        },
        data : pindata
      };
      
      axios.request(config)
      .then((res) => {
        if(res.data.success == 1){
          Swal.fire({
            icon: "success",
            title: "Success!",
            html: 'Your pin has been updated'
          })
        }else{
          Swal.fire({
            icon: "error",
            title: "Error!",
            html: 'An error has occurred.Try again later'
          })
        }      
      })
      .then(() => {
        setTimeout(() => {
          navigate(0);
        }, 2000);
      })
    }
  }

  const getRegions =() =>{
    let config = {
      method: 'get',
      maxBodyLength: Infinity, 
      url: `${API_URL}/get_regions`,
      headers: { 
        'Content-Type': 'application/json'
      }
    };
    
    axios.request(config)
    .then((response) => {
      setRegions(response.data)
    })
    .catch((error) => {
      console.log(error);
    });
  }

  useEffect(() => {
    getRegions();
  }, [])

  const getTowns =(regionId) =>{
    let config = {
      method: 'get',
      maxBodyLength: Infinity, 
      url: `${API_URL}/get_towns/${regionId}`,
      headers: { 
        'Content-Type': 'application/json'
      }
    };
    
    axios.request(config)
    .then((response) => {
      setTowns(response.data)
    })
    .catch((error) => {
      console.log(error);
    });
  }

  useEffect(() => {
    getTowns(regionId);
  }, [regionId])

  const [inputValues, setInputValues] = useState({
    refername: '',
    referphone: '',
    referregion: regionId,
    refertown: selectedTown
  });
  

  const handleReferRegionChange = (e) => {
    setRegionId(e.target.value);  
    getTowns(e.target.value);
    setSelectedTown('');
    const newdata1 = { ...inputValues, referregion: e.target.value, refertown: '' }
    newdata1[e.target.id] = e.target.value
    setInputValues(newdata1)
  }

  const handleReferTownChange = (e) => {
    setSelectedTown(e.target.value);
    const newdata1 = { ...inputValues, referregion: regionId, refertown: e.target.value }
    newdata1[e.target.id] = e.target.value
    setInputValues(newdata1)
  }

  const handleReferChange = (e) => {
    const newdata1 = { ...inputValues, referregion: regionId, refertown: selectedTown }
    newdata1[e.target.id] = e.target.value
    setInputValues(newdata1)
  }

  const handleReferSubmit = (e) => {
      e.preventDefault();
     
      setLoading(true);
      let formData = {
        "cust_name": inputValues.refername, 
        "phone_number": inputValues.referphone, 
        "region_id": inputValues.referregion, 
        "referral_id": logeduserData.Customer_no, 
        "source": "PORTAL",
        "town": inputValues.refertown,
        "package_name": null
      };

      let config = {
        method: 'post',
        maxBodyLength: Infinity, 
        url: `${API_URL}/create_newlead`,
        headers: { 
          'Content-Type': 'application/json'
        },
        data: formData
      };
      
      axios.request(config)
      .then((res) => {
        setLoading(false);
        if(res.data.success == 1){
          Swal.fire({
            icon: "success",
            title: "Success!",
            html: res.data.message
          })
          .then(() => {
            navigate(0); 
          });
        }else{
          Swal.fire({
            icon: "error",
            title: "Error!",
            html: res.data.message
          })
        } 
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
    }

return (
    <>
    <div className="logoutlang">
      <button onClick={logout} className="logout-button">
        {t('logout')}
      </button>
      <button className='userActions pin-button' id='changeUserPin' 
        onClick={() => {
          openModal3();
        }}> {t('change_pin')}</button>

      <Langpage />
    </div>
    <div className="self-carepage">
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="modal-container">
            <div className="modal-title">
              <i onClick={closeModal} className="fa fa-window-close red-close-icon" aria-hidden="true"></i>
            </div>
            <div className="titlestyle">
            {t('make_payment')}
            </div>
            <div className="modal-content">
              <form onSubmit={paySubscription}>
                <div className="user-details">
                  <div className="input-box">
                    <span className="details">{t('phone_number_maessage')}</span>
                    <input type="tel" 
                      placeholder="Enter paying phone number" 
                      value={phoneNumber}
                      onChange={handlePhoneChange}
                    />
                  </div>
                </div>
                 <div className="user-details">
                  <div className="input-box">
                    <span className="details">{t('package_upgrade')}</span>
                    {pakages.some(pk => pk.Description.includes(selectedItem)) && selectedItem !=="" ? 
                    <select
                      className='selecttxt'
                        type="tel"
                        value={selectedItem}
                        onChange={handleSelectionChange }
                      >
                        {pakages.map((pk, index) =>(
                          <option key ={index} value={pk.Description} id={pk.Code} >{pk.Description.split('-')[1]}</option>

                        ))}                      
                    </select> :
                    <select
                    className='selecttxt'
                      type="tel" 
                      value={selectedItem}
                    >                        
                    <option value={selectedItem}>{selectedItem.split('-')[1]}</option>                    
                  </select>
                  
                    }
                   
                  </div>
                </div>
                <div className="user-details">
                  <div className="input-box">
                    <span className="details">{t('subscription_amount')}</span>
                    <input type='tel'
                       value={selectedAmount}
                       onChange={handlePkgChange}
                    />
                  </div>
                </div>
                
               
                <div className="button">
                  <input
                    type="submit"
                    value={loading ? t('submitting') : t('submit')}
                    disabled={loading || !isInputValid}
                  />
                </div>
              </form>
            </div>
          </div>

        </Modal>

        <Modal
          isOpen={modal2IsOpen}
          onRequestClose={closeModal2}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="modal-container">
            <div className="modal-title">
              <i onClick={closeModal2} className="fa fa-window-close red-close-icon" aria-hidden="true"></i>
            </div>
            <div className="titlestyle">
            <span className='titlestyle'>{t('manage_wifi')}</span>
            </div>
            <div className="modal-content">
              <form onSubmit={changeWifiPass}>

                <div className="user-details">
                  <div className="input-box">
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
    <span className="details">{t('wifi_name')}</span>
    <span className="input-hint" style={{ fontSize: '10px', color: '#888', fontStyle: 'italic' }}>
    *letters and numbers only
    </span>
  
                  </div>
                    <input type="text"  
                      onChange={handleChange}
                      value={data.wifi_name}
                      id='wifi_name'
                    />
                  </div>
                  <div className='passvalidator'>{offlineMsg}</div>
                </div>
                <div className="user-details">
                  <div className="input-box">
                    <span className="details">{t('current_wifi_password')}</span>
                    <input type="text" 
                      readOnly
                      value={wifipassword}
                    />
                  </div>
                  <div className='passvalidator'>{offlineMsg}</div>
                </div>
                <div className="user-details">
                  <div className="input-box">
                    <span className="details">{t('enter_new_wifi_password')}</span>
                    <input type="text" 
                      placeholder={t('enter_new_wifi_password')} 
                      required 
                      onKeyDown ={handlekeydown}
                      onKeyUp={handleFocus}
                      onChange={handleChange}
                      id='newpass'
                    />
                  </div>
                  <div className='passvalidator'>{validatorMsg}</div>

                </div>
                
               
                <div className="button">
                  <input
                    type="submit"
                    value={loading ? t('submitting') : t('submit')}
                    disabled={loading}
                  />
                </div>
              </form>
            </div>
          </div>

        </Modal>

<Modal
  isOpen={modalfIsOpen}
  onRequestClose={closeModalf}
  style={customStyles}
  contentLabel="WiFi Settings Modal"
>
  <div className="modal-container">
    <div className="modal-title">
      <i onClick={closeModalf} className="fa fa-window-close red-close-icon" aria-hidden="true"></i>
    </div>
    <div className="titlestyle">
      <span className="titlestyle">{t('manage_wifi')}</span>
    </div>
    <div className="modal-content">
      <form onSubmit={changeWifif}>
        <div className="user-details">
  <div className="input-box">
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <span className="details">{t('wifi_name')}</span>
      <span className="input-hint" style={{ fontSize: '10px', color: '#888', fontStyle: 'italic' }}>
        *Letters and numbers only
      </span>
    </div>

    <input
      type="text"
      onChange={(e) => {
        const sanitized = e.target.value.replace(/[^A-Za-z0-9]/g, '');
        setData({ ...data, wifi_name: sanitized });
      }}
      value={data.wifi_name}
      id="wifi_name"
    />
  </div> 
  <div className="passvalidator">{offlineMsg}</div>
</div>

        <div className="user-details">
          <div className="input-box">
            <span className="details">{t('current_wifi_password')}</span>
            <input type="text" readOnly value={wifipassword} />
          </div>
        </div>

        <div className="user-details">
          <div className="input-box">
            <span className="details">{t('enter_new_wifi_password')}</span>
            <input
              type="text"
              placeholder={t('enter_new_wifi_password')}
              required
              onChange={(e) => {
                const newVal = e.target.value;
                setData({ ...data, newpass: newVal });

                if (newVal.trim().length < 8) {
                  setValidatorMsg("⚠️ Password must be at least 8 characters long");
                } else {
                  setValidatorMsg("");
                }
              }}
              id="newpass"
              value={data.newpass}
            />
          </div>
          {validatorMsg && (
            <div className="passvalidator">{validatorMsg}</div>
          )}
        </div>

        <div className="button">
          <input
            type="submit"
            value={loading ? t('submitting') : t('submit')}
            disabled={loading}
          />
        </div>
      </form>
    </div>
  </div>
</Modal>

        <Modal
          isOpen={modal3IsOpen}
          onRequestClose={closeModal3}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="modal-container">
            <div className="modal-title">
              <i onClick={closeModal3} className="fa fa-window-close red-close-icon" aria-hidden="true"></i>
            </div>
            <div className="titlestyle">
            {t('change_pin')}
            </div>
            <div className="modal-content">
              <form onSubmit={changeMyPin}>
                <div className="user-details">
                  <div className="input-box">
                    <span className="details">{t('enter_pin')}</span>
                    <input type="number" 
                      placeholder={t('enter_pin')} 
                      id='pin'
                      onChange={handlePinChange}
                      onKeyDown={handleKeyDown}
                      required
                    />
                  </div>
                </div>

                <div className="user-details">
                  <div className="input-box">
                    <span className="details">{t('confirm_pin')}</span>
                    <input type="number" 
                      placeholder={t('confirm_pin')} 
                      id='cpin'
                      onChange={handlePinChange}
                      onKeyDown={handleKeyDown}
                      required
                    />
                  </div>
                </div>              
               
                <div className="button">
                  <input
                    type="submit"
                    value={loading ? t('submitting') : t('submit')}
                    disabled={loading || !isInputValid}
                  />
                </div>
              </form>
            </div>
          </div>

        </Modal>

        <Modal
          isOpen={referIsOpen}
          onRequestClose={closeReferModal}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="modal-container">
            <div className="modal-title">
              <i onClick={closeReferModal} className="fa fa-window-close red-close-icon" aria-hidden="true"></i>
            </div>
            <div className="titlestyle">
            {t('refer_customer')}
            </div>
            <div className="modal-content">
              <form onSubmit={handleReferSubmit}>
                <div className="user-details">
                  <div className="input-box">
                    <span className="details">{t('name')}</span>
                    <input type="text"
                      id='refername' 
                      required
                      placeholder={t('enter_potential_customer_name')} 
                      onChange={handleReferChange}
                    />
                  </div>
                </div>
             
                <div className="user-details">
                  <div className="input-box">
                    <span className="details">{t('region')}</span>
                
                    <select className='selecttxt' id="referregion" onChange={handleReferRegionChange} required>
                      <option value="">{t('enter_potential_customer_region')}</option>
                      {regions.map((region, index) => (
                        <option key={index} value={region.id}>
                          {region.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="user-details">
                  <div className="input-box">
                    <span className="details">{t('town')}</span>
                    <select className='selecttxt' value={selectedTown} id="refertown" onChange={handleReferTownChange} required>
                      <option value="">{t('enter_potential_customer_town')} </option>
                      {towns.map((town, index) => (
                        <option key={index} value={town.name}>
                          {town.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="user-details">
                  <div className="input-box">
                    <span className="details">{t('phone')}</span>
                    <input type="text" 
                      id='referphone'
                      required
                      placeholder={t('enter_potential_customer_contact')}  
                      onChange={handleReferChange}
                    />
                  </div>
                </div>
                
               
                <div className="button">
                  <input
                    type="submit"
                    value={loading ? t('submitting') : t('submit')}
                    disabled={loading || !isInputValid}
                  />
                </div>
              </form>
            </div>
          </div>

        </Modal>

        <Modal
          isOpen={modalSupportIsOpen}
          onRequestClose={closeModalSupport}
          style={customStyles}
          contentLabel="Support Ticket Modal"
        >
          <div className="modal-container">
            <div className="modal-title">
              <i onClick={closeModalSupport} className="fa fa-window-close red-close-icon" aria-hidden="true"></i>
            </div>
            <div className="titlestyle">
              {t('Need Support')}
            </div>
            <div className="modal-content">
              <form onSubmit={createTicket}>
                <div className="user-details">
                  <div className="input-box">
                    <span className="details">{t('Select Issue Type')}</span>
                    <select
                      className='selecttxt'
                      id='issuetype'
                      value={ticketData.issuetype}
                      onChange={handleTicketChange}
                      required
                    >
                      <option value="">{t('select')}</option>
                      <option value="19">No Internet</option>
                      <option value="40">Slow Internet</option>
                      <option value="1">Other</option>
                    </select>
                  </div>
                </div>

                <div className="user-details">
                  <div className="input-box">
                    <span className="details">{t('Message')}</span>
                    <textarea
                      className='ticket-textarea'
                      id='c_message'
                      placeholder={t('Explain Your Issue In Detail')}
                      value={ticketData.c_message}
                      onChange={handleTicketChange}
                      required
                      rows={5}
                    />
                  </div>
                </div>

                {errorMessage && <div className="passvalidator">{errorMessage}</div>}

                <div className="button">
                  <input
                    type="submit"
                    value={loading ? t('submitting') : t('submit')}
                    disabled={loading}
                  />
                </div>
              </form>
            </div>
          </div>

        </Modal>

        <div className="home-content">
          <img src={avatar} className="logo" alt="Mawingu" />

    <p className="welcome-text">
        Welcome back
    </p>

    <h1 className="customer-name">
        {capitalizeFirstLetter(details?.name)}
    </h1>

    {/* Renewal Banner */}

    <div className="renew-banner">
    <div className="renew-icon">
        <i className="fa fa-bell-o"></i>
    </div>

    <div>
        <h4>
            {daysRemaining > 0
                ? `Your plan renews in ${daysRemaining} day${daysRemaining > 1 ? "s" : ""}`
                : "Your plan has expired"}
        </h4>

        <p>
            {daysRemaining > 7
                ? "Renew early to stay connected"
                : daysRemaining > 0
                ? "Your renewal is approaching"
                : "Renew now to reconnect"}
        </p>
    </div>
</div>

    {/* Package Card */}

 <div className="package-card">

    <div className="package-header">
        <span className="package-label">Current package</span>

       <span className={`status-badge ${
    details?.status?.toLowerCase() || 'blocked'
}`}>
    {details?.status || "Blocked"}
    <span className="status-dot"></span>
</span>
    </div>

    <h2 className="package-name">
        {details?.package_code?.split("-")[1]}
    </h2>

    <hr />

    <div className="package-footer">
        {/* Left Column */}
        <div className="footer-col">
            <p>Account number: <strong>{logeduserData.Customer_no}</strong></p>
            <p>Renewal date: <strong>{formattedDate}</strong></p>
            <p>WiFi password: <strong>{wifipassword || "—"}</strong></p>
        </div>

        {/* Right Column */}
        <div className="footer-col">
            <p>
                Customer Balance: <strong>
                    {details?.balance !== undefined && details?.balance !== "" && details?.balance !== null
                        ? `Ksh ${Number(String(details.balance).replace(/,/g, '')).toLocaleString()}`
                        : "N/A"}
                </strong>
            </p>

            <p>
                Amount to pay: <strong>
                    {details?.package_amount !== undefined && details?.balance !== undefined && details?.package_amount !== "" && details?.balance !== ""
                        ? `Ksh ${(
                            parseFloat(String(details.package_amount).replace(/,/g, '')) +
                            Number(String(details.balance).replace(/,/g, ''))
                          ).toLocaleString()}`
                        : "N/A"}
                </strong>
            </p>
        </div>
    </div>

</div>

    {/* action card */}
    <div className="dashboard-actions">

    <div
        className="action-card primary"
        onClick={() => {
            openModal();
            saveLogs(
                logeduserData.Customer_no,
                logeduserData.phone,
                "Renew subscription",
                details?.email_address
            );
        }}
    >
        <i className="fa fa-money"></i>
        <span>Pay Now</span>
    </div>

    <div
        className="action-card"
        onClick={() => {
            details?.ip_address?.startsWith("10.40")
                ? openModalf()
                : openModal2();

            saveLogs(
                logeduserData.Customer_no,
                logeduserData.phone,
                "Manage WiFi",
                details?.email_address
            );
        }}
    >
        <i className="fa fa-wifi"></i>
        <span>Manage WiFi</span>
    </div>

    <div
        className="action-card"
        onClick={handleInvoicesClick}
    >
        <i className="fa fa-file-text-o"></i>
        <span>Invoices</span>
    </div>

    <div
        className="action-card"
        onClick={handleReceiptsClick}
    >
        <i className="fa fa-list-alt"></i>
        <span>Receipts</span>
    </div>

    <div
        className="action-card"
        onClick={() => {
            openModalSupport();
            saveLogs(
                logeduserData.Customer_no,
                logeduserData.phone,
                "Need Support",
                details?.email_address
            );
        }}
    >
        <i className="fa fa-life-ring"></i>
        <span>Need Support</span>
    </div>

    <div
        className="action-card"
        onClick={handleConnectedClick}
    >
        <i className="fa fa-clone"></i>
        <span>Connected Devices</span>
    </div>

    <div
        className="action-card refer-card"
        onClick={() => navigate("/refer")}
    >
        <i className="fa fa-user-plus"></i>
        <span>Refer a customer</span>
    </div>

</div>
                               
 <div className="support-call">
  <a
    href="https://mawingu.co/terms-and-conditions/"
    target="_blank"
    rel="noopener noreferrer"
  >
    {t('TermsAndConditions')}
  </a>
  {' | '}
  <a
    href="http://mawingu.co/privacy-policy/"
    target="_blank"
    rel="noopener noreferrer"
  >
    {t('PrivacyPolicy')}
  </a>
</div>

<div className="copyright">
  {t('copyright')} © {currentYear} - Mawingu
</div>
        </div>
        <ToastContainer
          position="top-center"
          autoClose={4000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          style={{ top: '30%', left: '50%', transform: 'translate(-50%, -50%)' }}
        />
    </div>
    </>
)
}

export default Home
